module.exports = __webpack_public_path__ + "static/media/picture1.8f403c28.jpg";